import {type ClassValue, clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
// ─── Form data mapper ─────────────────────────────────────────────────────────
export function sanitizeText(raw: string): string {
  return (
    raw
      .normalize('NFC')
      .replace(/\r\n|\r/g, '\n')
      // eslint-disable-next-line no-control-regex -- intentionally stripping control characters
      .replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f-\u009f]/gu, '')
      // eslint-disable-next-line no-misleading-character-class -- intentionally stripping zero-width/bidi characters
      .replace(/[\u200b\u200c\u200d\u200e\u200f\ufeff]/gu, '')
      .trim()
  );
}
